export enum SupportedLanguage {
	EN = "en",
	NB = "nb",
	SV = "sv",
}
